"use client";

import React from "react";
import EventTicker from "@/components/common/EventTicker";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import dynamic from "next/dynamic";
import CPACourseBanner from "@/components/newPageComponent/cpa-new/course/CPACourseBanner";
import CPACourseDetails from "@/components/newPageComponent/cpa-new/course/CPACourseDetails";
import CPACourseDuration from "@/components/newPageComponent/cpa-new/course/CPACourseDuration";
import CPACourseFee from "@/components/newPageComponent/cpa-new/course/CPACourseFee";
import About_cpa_course from "@/components/newPageComponent/cpa-new/course/About_cpa_course";
import CPACourseEligibility from "@/components/newPageComponent/cpa-new/course/CPACourseEligibility";
import InfoTicker from "@/components/newPageComponent/cpa-new/course/InforTicket";
import StickyFooter from "@/components/newPageComponent/CommonSection/StickyFooter";
import WhyChooseMiles from "@/components/newPageComponent/cpa-new/course/WhyChooseMiles";
import CpaCourseFaq from "@/components/newPageComponent/cpa-new/course/CpaCourseFaq";
import PreferredSourceBanner from "@/components/blogs/PreferredSourceBanner";

const NewInactivityPopup = dynamic(
  () =>
    import("@/components/newPageComponent/CommonSection/NewInactivityPopup"),
  { ssr: false },
);

const PageContent: React.FC = () => {
  return (
    <>
      <div className="w-full bg-white">
        <EventTicker />
        <GlobalHeaderNew />
        <CPACourseBanner />
        <InfoTicker
          items={[
            {
              highlight: "100+",
              suffix: "  University Partner",
            },
            { highlight: "600+", suffix: " Employer Collaborations" },
            { highlight: "1,000+", suffix: " Students Placed in the U.S." },
            { highlight: "70,000+", suffix: " Global Alumni" },
            { highlight: "", suffix: " Global Career Pathways" },
          ]}
        />
        <About_cpa_course />
        <PreferredSourceBanner/>
        <CPACourseDetails />
        <CPACourseEligibility />
        <CPACourseDuration />
        <CPACourseFee />
        <WhyChooseMiles />
        <CpaCourseFaq />
        <GlobalFooter />
        <StickyFooter pageName="CPA" courseID={1} />
        <NewInactivityPopup pageName="CPA" courseId={1} delay={7000} />
      </div>
    </>
  );
};

export default PageContent;
